<div *ngIf="hasMoreItems && canPrev" class="phx-carousel-nav phx-carousel-prev" (click)="onPrev()">
	<ng-container [ngTemplateOutlet]="phxLeftNavigationTemplate"></ng-container>
</div>

<div #scrollContainer class="phx-carousel-track" data-e2e="carousel-track">
	<div #innerTrack class="phx-carousel-track-inner">
		<ng-content select="[phx-carousel-item]"></ng-content>
	</div>
</div>

<div *ngIf="hasMoreItems && canNext" class="phx-carousel-nav phx-carousel-next" (click)="onNext()">
	<ng-container [ngTemplateOutlet]="phxRightNavigationTemplate"></ng-container>
</div>

<button
	*ngIf="phxShowExpandButton"
	phx-icon-button
	class="phx-carousel-expand"
	[phxIcon]="fullScreenIcon"
	phxIconButtonType="on-overlay"
	phxIconButtonSize="extra-extra-small"
	(click)="onExpand()"
	aria-label="Gallery view"
></button>

<phx-pagination
	*ngIf="showPaginationOverlay"
	class="phx-carousel-pagination"
	[phxTotalItems]="items.length"
	[phxPerPageCount]="1"
	[phxCurrentPage]="currentIndex + 1"
	[phxHidePagination]="false"
	[phxHideContentOnMobile]="false"
	phxSize="extra-small"
	[phxBackground]="'overlay'"
	(phxOnNavigate)="onPaginationNavigate($event)"
></phx-pagination>

<ng-container #galleryHost></ng-container>
